import {
  EXTERNAL_API_GET_PERMISSION_FLAGS_BEGIN,
  EXTERNAL_API_GET_PERMISSION_FLAGS_SUCCESS,
  EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE,
  EXTERNAL_API_GET_PERMISSION_FLAGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getPermissionFlags(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EXTERNAL_API_GET_PERMISSION_FLAGS_BEGIN,
    });
    const { projectId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(`${process.env.REACT_APP_BUILDER_ENGINE}permissions/get`, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EXTERNAL_API_GET_PERMISSION_FLAGS_SUCCESS,
              data: res.data,
            });
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE,
              data: { error: 'Failed' },
            });
            resolve('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetPermissionFlagsError() {
  return {
    type: EXTERNAL_API_GET_PERMISSION_FLAGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_GET_PERMISSION_FLAGS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getPermissionFlagsPending: true,
        getPermissionFlagsError: null,
      };

    case EXTERNAL_API_GET_PERMISSION_FLAGS_SUCCESS:
      // The request is success
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: null,
        permissionFlags: action.data,
      };

    case EXTERNAL_API_GET_PERMISSION_FLAGS_FAILURE:
      // The request is failed
      return {
        ...state,
        getPermissionFlagsPending: false,
        getPermissionFlagsError: action.data.error,
      };

    case EXTERNAL_API_GET_PERMISSION_FLAGS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getPermissionFlagsError: null,
      };

    default:
      return state;
  }
}
